module.exports = __webpack_public_path__ + "static/media/Omnivati-login-logo.cba9dd31.svg";